import React from 'react';
import ReactDOM from 'react-dom';

import App from './App';
import './styles/master.css';
import './styles/bulma.css';

//component global aqui
ReactDOM.render(<App />, document.getElementById('root'));
